function initSuppHeroSlider() {
  var heroes = document.querySelectorAll('.supp-hero');

  if (!heroes.length) return;

  heroes.forEach(function (hero) {
    var mainEl = hero.querySelector('.js-supp-hero-slider');

    if (!mainEl || mainEl.dataset.swiperInit) return;

    var thumbsEl = hero.querySelector('.js-supp-hero-thumbs');
    var thumbsSwiper = null;

    if (thumbsEl && !thumbsEl.dataset.swiperInit) {
      thumbsEl.dataset.swiperInit = '1';

      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 12,
        watchSlidesProgress: true,
        loop: false,
        freeMode: true,
        mousewheel: true,
        speed: 800,
        breakpoints: {
          0: {
            direction: 'horizontal',
            slidesPerView: 4.5,
          },
          992: {
            direction: 'vertical',
            slidesPerView: 4,
          },
        },
      });
    }

    mainEl.dataset.swiperInit = '1';

    new Swiper(mainEl, {
      loop: false,
      speed: 800,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
    });
  });
}

/* Swiper is loaded globally in theme.liquid. If it's deferred, wait for it. */
function whenSuppHeroSwiperReady(cb) {
  if (typeof window.Swiper !== 'undefined') return cb();

  var tries = 0;
  var timer = setInterval(function () {
    if (typeof window.Swiper !== 'undefined' || ++tries > 50) {
      clearInterval(timer);
      if (typeof window.Swiper !== 'undefined') cb();
    }
  }, 100);
}

document.addEventListener('DOMContentLoaded', function () {
  whenSuppHeroSwiperReady(initSuppHeroSlider);
});

document.addEventListener('shopify:section:load', function () {
  whenSuppHeroSwiperReady(initSuppHeroSlider);
});
